import { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import EditFormMono from './../../components/editForms/editFormMono';
import { apiClient } from "../../api/apiClient";

function EditBook() {
    let { id } = useParams();

    const [bookData, setBookData] = useState({});

    useEffect(() => {
        async function getData() {
            const req = await apiClient.get(`/book/${id}`);

            if (req.status === 200) {
                setBookData(req.data.data);
            }
        }

        getData()
    }, [id]);

    return (
        <div>
            <EditFormMono book={bookData} />
        </div>
    )
};

export default EditBook;